<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <iframe :src="block.iframe.languageProxy.src" :style="iframeStyle"/>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";

// cms-block-youtube-video #hot-reload-debug
export default {
    name: `cms-block-youtube-video`,
    components: {CmsBlock},
    extends: CmsBlock,
    computed: {
        iframeStyle() {
            let style = {
                borderRadius: this.block.iframe.mediaProxy.borderRadius
            }
            if (this.block.iframe.mediaProxy.height) {
                style.height = `${this.block.iframe.mediaProxy.height}px`;
            } else {
                style.aspectRatio = this.block.iframe.mediaProxy.aspectRatio;
            }
            return style;
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-block-youtube-video {
    width: 100%;
}
iframe {
    border: none;
    width: 100%;
}
</style>
